export class SaHelpVideoModal {

  id: string;
  title: string;
  description: string;
  videoType: number;
  url: string;
  categoryId: string;
  categoryName: string;
  urlShow: string;
  
}
